<ng-container *ngIf="!showReceiptChoice">
    <div class="py-40 px-10 text-center text-xl text-bold">
        <div *ngIf="isLoading" class="flex flex-col justify-center items-center py-6">
            <div class="py-12 text-6xl font-bold">
                {{ loadingMessage }}
            </div>
        </div>

        <div *ngIf="!isLoading && !showReceiptChoice" class="flex justify-center items-center py-6 text-6xl font-bold">
            Suivez les instructions sur le terminal de paiement.
        </div>

        <div class="text-6xl mt-24" *ngIf="!showReceiptChoice">
            {{ statusMessage }}
        </div>

        <div *ngIf="errorMessage" class="mt-12 text-center text-6xl text-error-800">
            {{ errorMessage }}
        </div>

        <ng-container *ngIf="isOnError">
            <div class="mt-12 flex flex-row justify-center">
                <app-button-atom size="XXL" thickSize="XXL" label="Réessayer" (click)="createOrder()"
                                 type="primary"></app-button-atom>
            </div>
            <div class="mt-12 flex flex-row justify-center">
                <app-button-atom size="XXL" thickSize="XXL" label="Retourner au panier" (click)="backToCart()"
                                 type="light"></app-button-atom>
            </div>
        </ng-container>
    </div>

    <app-kiosk-cart-reset-timer-block
            *ngIf="loadKioskResetTimer"
            [waitForUserInteractionToDisplayModal]="false"
    ></app-kiosk-cart-reset-timer-block>
</ng-container>

<ng-container *ngIf="showReceiptChoice">
    <div class="fixed inset-0 z-50 bg-white flex flex-col items-center justify-center text-center">
        <div class="mb-24 text-6xl font-bold">
            Paiement accepté
        </div>

        <div class="text-5xl font-bold mb-24">
            Souhaitez vous imprimer un reçu ?
        </div>

        <div class="flex justify-center gap-8 flex-wrap">
            <app-button-atom
                    size="XXL"
                    thickSize="XXL"
                    label="Non, continuer sans reçu"
                    (click)="skipReceiptAndContinue()"
                    type="primary"
            ></app-button-atom>

            <app-button-atom
                    size="XXL"
                    thickSize="XXL"
                    [label]="'Oui, imprimer le reçu (' + receiptPrintCountdown +')'"
                    (click)="printReceiptAndContinue()"
                    type="primary"
            ></app-button-atom>
        </div>
    </div>

</ng-container>
